import React from 'react';
import { useGetOptions, SelectInputProps } from "../../../../../hooks/report/useGetOptions";
import { BoundSelect } from "../BoundSelect";
import { LocationDisplayStatus } from "../../../../../types/LocationStatus";

type BoundLocationDisplayStatusSelectProps<T> = {
  label?: string;
  name: string;
  value?: string | number | null;
  onChange: (newQuery: T) => void;
}

const BoundLocationDisplayStatusSelect = <T,>({
  label = "Location Status",
  name,
  value = '',
  onChange
}: BoundLocationDisplayStatusSelectProps<T>) => {

  return <BoundSelect<T>
    options={useGetOptions({optionFormat: 'SELECT', options: LocationDisplayStatus}) as unknown as SelectInputProps[]}
    label={label}
    name={name}
    value={value}
    onChange={onChange}
  />
}

export { BoundLocationDisplayStatusSelect };